import globalActions from "../api/GlobalActions.js"
import globalMutations from "../api/GlobalMutations.js"
import globalGetters from "../api/GlobalGetters.js"

export const state = () => ({
  isStale: true,
  latest_fetch: "",
  type: "districts",
  pageLayout: "StructureTable",
  effectedByYear: false,
  yearFields: [],
  canEdit: false,
  canView: false,
  aliasField: "name",
  modelLabels: {
    single: "District",
    plural: "Districts"
  },
  filterOverrides: ["audits"],
  relations: [
    {
      name: "audits",
      translate: "audits",
      label: "Audits",
      value: "audits",
      storename: "audits",
      yearFields: [],
      export: false
    },
    {
      name: "farmunits",
      translate: "farmunits",
      label: "Farm Unit",
      value: "farmunits",
      storename: "farmunits",
      yearFields: []
    },
    {
      name: "diversionPoints",
      translate: "diversionPoints",
      label: "Turnout",
      value: "diversionPoints",
      storename: "diversionPoints",
      yearFields: []
    },
    // {
    //   name: "maintenanceRequests",
    //   translate: "maintenanceRequests",
    //   value: "maintenanceRequests",
    //   storename: "maintenanceRequests",
    //   yearFields: []
    // },
    {
      name: "sibling",
      translate: "districts",
      label: "Sibling District",
      value: "districts",
      storename: "districts",
      yearFields: []
    }
  ],
  all: {},
  reference: {
    /* for showing paginated resources ... needs a bit more work. */
  },
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: "name",
    page: 1,
    sortDesc: []
  },
  print_path: "",
  search: null,
  searchFields: ["name"/*, "short_id" */],
  total: 0,
  print: false,
  export: false,
  // this will need to by dynamic based on user config valuese
  bound: {
    // name: "",
  },
  filter: {
    // name: "",
  },
  quickFilters: [],
  stub: {
    audits: [],
    canals: [],
    farmunits: [],
    diversionPoints: [],
    sibling: []
  },
  // members are called contractors on the server
  include: "sibling,audits",
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
